import { Geolocation } from '@ionic-native/geolocation';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, Content, NavController, NavParams, ViewController, ActionSheetController, LoadingController, ToastController } from 'ionic-angular';
import { CategoriesProvider } from '../../../../providers/categories/categories';
import { EventProvider } from '../../../../providers/event/event';
import { GoogleMapsProvider } from '../../../../providers/google-maps/google-maps';
import { UserProvider } from '../../../../providers/user/user';
import { ValueProvider } from '../../../../providers/value/value';
import { SessionProvider } from '../../../../providers/session/session';
import { TutorialProvider } from '../../../../providers/tutorial/tutorial';
import { NewsRespond, NewsController } from '../../../../providers/news/news-contoller';
import { NotificationPage } from '../../../notification/main/notification';
import { Storage } from '@ionic/storage';
import { AppDetectorProvider } from '../../../../providers/detector/detector';
import { ResultProvider } from '../../../../providers/result/result';
import { EventActivityUtils } from './event-activity-utils';
import { StorageProvider } from '../../../../providers/storage-service/storage-service';
import { ResultDescriptionPage } from '../../../results/result-description/result-description';
import { WrappedStatistics } from '../../../../tracker/run-statistics/run-statistics';
import { StrackerProvider } from '../../../../providers/stracker/stracker';
import { TestPage } from '../../../test-page/test-page';
import { MONTH } from '../../../../providers/activities.service';
import { ScreenRotatableService } from '../../../../providers/screen-rotatable/screen-rotatable.service';
import { ThemeMode } from '../../../../providers/dark-mode/dark-mode';

declare var google;

@Component({
  selector: 'page-event-activity',
  templateUrl: 'event-activity.html'
})
export class EventActivityPage {
  @Input('instance') parentInstance;

  treesCounter = {
    kilometer: "000",
    units: "000",
    trees: "000"
  };

  trainings = [];
  collected = false;

  endurances: any = [];
  activeEndurance: any = null;
  isLoading: boolean = true;

  shownGroup = null;
  shownMonthGroup = null;
  shownWeekGroup = null;
  activeSegmentId = 0;

  // For testing purposes
  test: boolean = false;
  noActivitiesMessage:string ="";

  // theme
  themeMode

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public categoriesService: CategoriesProvider,
    public valueService: ValueProvider,
    public eventService: EventProvider,
    public userService: UserProvider,
    public app: App,
    public translate: TranslateService,
    public loadingCtrl: LoadingController,
    public viewCtrl: ViewController,
    public geoLocation: Geolocation,
    public googleService: GoogleMapsProvider,
    public detector: ChangeDetectorRef,
    private sessionService: SessionProvider,
    private tutorialProvider: TutorialProvider,
    private actionSheetCtrl: ActionSheetController,
    private storage: Storage,
    private appDetector: AppDetectorProvider,
    private resultService: ResultProvider,
    private storageService: StorageProvider,
    private toastController: ToastController,
    private screen: ScreenRotatableService,
    private strackerService: StrackerProvider
  ) {
    console.log('[event-activity] constructor');
    this.noActivitiesMessage = this.translate.instant('NO_ACTIVITIES');
    this.initialize();
  }

  initInformMessage(){
    if(!this.activeEndurance)
      this.noActivitiesMessage = this.translate.instant('NO_ACTIVITIES');
  }
  initialize() {
    if (this.sessionService.isLoged) {
      this.getTrainingsData();
      this.getEndurances();
      // if (NewsController.getInstance().isAllowed) this.checkNews();
    }
  }

  ionViewWillEnter() {
    this.initialize();
  }

  ngOnInit() {
    this.screen.lockPortraitOrientation();
    this.themeMode= JSON.parse(localStorage.getItem('darkMode') || `"${ThemeMode.LightMode}"`) as ThemeMode;
  }

  ionViewDidLoad() {
    console.log('[event-activity] did load');
  }

  getTrainingsData() {
    this.eventService.getTrainings().then((trees: TreesCounter[]) => {
      console.log('getTrainings (): ');
      if (!trees) return;
      this.treesCounter.kilometer = Math.floor(trees.reduce((acc, cur) => acc + cur.distMeterSum, 0) / 1000) + "";
      this.treesCounter.trees = Math.floor(Number(this.treesCounter.kilometer) / 50) + "";
    }).catch(err => {
      console.log('err-getTrainings: ', err);
    });
  }

  getToFixed(value: number) {
    return ((Number(value.toFixed(1)) % 1) > 0) ? value.toFixed(1) : Number(value.toFixed(1));
  }

  async getEndurances() {
    if (!this.sessionService.isLoged) return;
    this.resultService.getEndurances().then((endurances) => {
      console.log('endurances: ', endurances);
      this.filterEndurances(endurances).then(async (filteredEndurances) => {
        console.log('filteredEndurances: ', filteredEndurances);
        localStorage.setItem('filteredEndurances', JSON.stringify(filteredEndurances));
        this.endurances = filteredEndurances;
        this.activeEndurance = filteredEndurances[0];

        await this.storageService.getSaved('track-mode').then((mode) => {
          if (mode) {
            this.activeEndurance = mode;
            let index = this.endurances.map(x => x.name).indexOf(mode.name);
            this.activeSegmentId = (index >= 0) ? index : 0;
          }
        });

        this.fillInTable();
      })
    });
  }

  filterEndurances(endurances): Promise<any> {
    console.log('fe-1');
    let array = [];
    return new Promise<any>((resolve, reject) => {
      this.sessionService.getToken(false, false).then((token) => {
        console.log('fe-2');
        this.eventService.getTrainings().then(async (trees: TreesCounter[]) => {
          console.log('fe-3');
          this.trainings = Object.assign([], trees);
          for (let i = 0; i < this.trainings.length; i++) {
            for (let j = 0; j < endurances.length; j++) {
              await this.eventService.getMonthlyStatsPerYearCid(token, this.trainings[i].year, endurances[j].id).then(async (kmPerYear) => {

                if (kmPerYear.length) {
                  endurances[j].hasData = true;
                  if (!array.includes(endurances[j]))
                    array.push(endurances[j]);
                }
              });
            }
          }
          resolve(array);
        });
      });
    });
  }


  fillInTable(): Promise<any> {
    console.log('f-1');
    return new Promise<any>((resolve, reject) => {
      if (this.sessionService.isLoged) {
        this.sessionService.getToken(false, false).then((token) => {

          this.eventService.getTrainings().then(async (trees: TreesCounter[]) => {
            localStorage.setItem('ucts.token', JSON.stringify(trees));
            this.trainings = Object.assign([], trees);
            for (let i = 0; i < this.trainings.length; i++) {
              if (!this.activeEndurance) {this.isLoading = false; resolve(null); return; }
              await this.eventService.getMonthlyStatsPerYearCid(token, this.trainings[i].year, this.activeEndurance.id).then((kmPerYear) => {
                console.log('kmPerYear: ', kmPerYear);

                this.trainings[i].yearStats = kmPerYear.reduce((acc, cur) => acc + cur.distMeterSum, 0);
                if (this.trainings[i].yearStats) {
                  for (let m = 0; m < kmPerYear.length; m++) {
                    if (typeof this.trainings[i].monthly === "undefined") {
                      this.trainings[i].monthly = [];
                    }
                    this.trainings[i].monthly.push({ monthIndex: kmPerYear[m].monthNo, monthName: this.translate.instant(MONTH[kmPerYear[m].monthNo - 1]), monthDistance: kmPerYear[m].distMeterSum, monthStats: [] });
                  }
                }
                if (typeof this.trainings[i].monthly !== "undefined") this.trainings[i].monthly.reverse();
              });
            }
            this.trainings.reverse();
            this.shownGroup = 0;
            this.collected = true;
            this.isLoading = false;
            resolve(this.trainings);
          });
        });
      } else {
        resolve('the user is not authenticated');
      }
    });
  }

  hasData(index: number) {

  }

  getDateFormatted(date) {
    return EventActivityUtils.getDDMM(date)
  }

  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      this.shownGroup = null;
    } else {
      this.shownGroup = group;
    }
  }

  isGroupShown(group) {
    return this.shownGroup === group;
  }

  async toggleMonthGroup(i, m, group) {
    await this.getWeeklyGroup(i, m, group);
    if (this.isMonthGroupShown(m)) {
      this.shownMonthGroup = null;
    } else {
      this.shownMonthGroup = m;
    }
  }

  getWeeklyGroup(i, m, group) {
    this.sessionService.getToken().then(token => {
      this.eventService.getMonthlyStatsPerYearCidMonth(token, this.trainings[i].year, this.activeEndurance.id, group.monthIndex).then((monthStats) => {

        if (monthStats && monthStats.length > 0) {
          let weeks = [];

          for (let j = 0; j < monthStats.length; j++) {
            let monday = EventActivityUtils.getDDMM(EventActivityUtils.getLastMonday(monthStats[j].dt));
            let sunday = EventActivityUtils.getDDMM(EventActivityUtils.getUpcomingSunday(monthStats[j].dt));
            let weekKey = monday + "-" + sunday;
            let index = -1;

            for (let a = 0; a < weeks.length; a++) {
              if (weeks[a].key.includes(weekKey)) {
                index = a;
              }
            }

            if (index >= 0) {
              weeks[index].data.push(monthStats[j]);
            } else {
              weeks.push({ key: weekKey, sumDistance: 0, data: [monthStats[j]] })
            }
          }

          for (let j = 0; j < weeks.length; j++) {
            let sum = weeks[j].data.reduce((acc, cur) => acc + cur.distMeter, 0);
            weeks[j].sumDistance = sum;
          }

          this.trainings[i].monthly[m].monthStats = weeks;
          console.log('this.trainings: ', this.trainings);
        }
      });
    });
  }

  isMonthGroupShown(group) {
    return this.shownMonthGroup === group;
  }

  toggleWeekGroup(group) {
    if (this.isWeekGroupShown(group)) {
      this.shownWeekGroup = null;
    } else {
      this.shownWeekGroup = group;
    }
  }

  isWeekGroupShown(group) {
    return this.shownWeekGroup === group;
  }

  checkNews() {
    if (this.appDetector.isForestApp() || this.appDetector.isTournamentApp()) return;

    NewsController.getInstance().getNews().then((respond) => {
      this.tutorialProvider.isFirstRun().then(status => {
        if (!status) {
          if (respond.update) {
            if (respond.type.includes("DHL")) {
              this.userService.checkLoged().then(logged => {
                if (logged) {
                  if (this.sessionService.profile.clubName.includes("DHL"))
                    this.presentNewsActionSheet(respond);
                }
                else
                  return;
              });
            } else {
              this.presentNewsActionSheet(respond);
            }
          }
        } else {

          this.storage.remove('news-general').then(() => {
            this.storage.remove('news-dhl').then(() => {
              this.tutorialProvider.setTutorialDone();
            })
          });
        }
      })
    });
  }

  presentNewsActionSheet(respond: NewsRespond) {
    if (respond.type.includes("DHL")) {
      return;
    }

    let actionSheet = this.actionSheetCtrl.create({
      title: this.translate.instant('NEW_NEWS'),
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            if (respond.type.includes("DHL")) {
              if (this.sessionService.profile.clubName.includes("Deutsche Post DHL Group")) {
                (this.app.getRootNav() as NavController).push(NotificationPage, { news: respond.data, dhl: true });
              }
            }
            else {
              this.app.getRootNav().getActiveChildNav().select(1);
            }
          }
        },
        {
          text: this.translate.instant('GLOBAL_CANCEL'),
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });

    actionSheet.present();
  }

  onSegmentChange(endurance, index) {
    this.activeSegmentId = index;
    this.strackerService.saveData(endurance, "track-mode");
    this.activeEndurance = endurance;
    this.parentInstance.activeEndurance = this.activeEndurance;
    this.collected = false;
    this.fillInTable();
  }

  getImage(endurance) {
    if(this.themeMode =='darkMode'){
      return "assets/imgs/sportart_svg/" + this.convertSportType(endurance.name.toLocaleLowerCase()) + "-white.svg";
    }
    return "assets/imgs/sportart_svg/" + this.convertSportType(endurance.name.toLocaleLowerCase()) + ".svg";
  }

  convertSportType(mode: string) {
    let result = mode;
    if (mode.includes("inline")) {
      result = "inlineskating";
    } else if (mode.includes("indoor")) {
      result = "indoorbicycle";
    }
    return result;
  }

  async onTest() {
    this.fillInTable();
  }

  onChartLoad() {
    console.log(this.trainings);
    this.navCtrl.push(TestPage, { events: this.trainings });
  }

  onDayClick(event) {
    this.eventService.getEventRouteOverview(event.id).then((routeOverview) => {
      if (typeof routeOverview !== "undefined" && routeOverview.routeData && routeOverview.routeData.length != 0) {
        const results = this.prepareActivityResults(event, routeOverview);
        this.navCtrl.push(ResultDescriptionPage, { statisticsResults: results });
        return;
      }
      
      const toast = this.toastController.create({
        message: this.translate.instant("NO_ROUTE_ERROR_MESSAGE"),
        position: "top",
        duration: 3000
      });
      toast.present();
    });
  }

  prepareActivityResults(event, routeOverview) {
    const routeData = JSON.parse(routeOverview.routeData);
    if (routeData.routeInfos && routeData.routeInfos.length > 0) {
      const route = routeData.routeInfos[0].path;
      let decodedPath = this.decodePolyline(route);
      let encodedStatistics;
      if (event.title && event.title.length > 0) {
        encodedStatistics = JSON.parse(decodeURI(event.title));
      }

      let result: WrappedStatistics = {
        userId: -1,
        eventId: event.id,
        eventCid: event.cid || routeOverview.categoryName,
        totalTime: event.totalTimeSec,
        totalTimeFormatted: event.totalTimeSecFormatted,
        totalDistance: event.distMeter,
        eventName: routeOverview.routeName,
        routePoints: decodedPath,
        kmStatistics: encodedStatistics || [],
        hasRoute: true
      }

      return result;
    }
  }

  decodePolyline(encoded: string) {
    let index = 0;
    let lat = 0;
    let lng = 0;
    const coordinates = [];

    while (index < encoded.length) {
      let shift = 0;
      let result = 0;
      let byte;

      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);

      const dlat = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
      lat += dlat;

      shift = 0;
      result = 0;

      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);

      const dlng = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
      lng += dlng;

      coordinates.push([lat / 1e5, lng / 1e5]);
    }

    return coordinates;
  }
}


export interface TreesCounter {
  cid: number;
  distMeterSum: number;
  id: number;
  key: string;
  templateData: any;
  year: number;
}




// WEBPACK FOOTER //
// /src/pages/event/event-activity-tabs/event-forest/event-activity.ts